import { Component, OnInit, ViewChild } from '@angular/core';
import { WizardStep } from '../../../../../wizard/wizard.component';
import { MatTabGroup } from '@angular/material';
// tslint:disable-next-line:max-line-length
import { StudyReportDeliveryEditInfo } from '../../../../../model/logistics/study-report/study-report-delivery-edit-info';
import { Router, ActivatedRoute } from '@angular/router';
import { LogisticsService } from '../../../../../services/logistics.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { StudyReportDeliveryPatientComponent } from '../study-report-delivery-patient/study-report-delivery-patient.component';
import { StudyReportDeliveryDetailComponent } from '../study-report-delivery-detail/study-report-delivery-detail.component';
import { StudyReportDeliveryWizard } from 'src/app/services/wizard/logistic/study-report-delivery-wizard.service';

@Component({
  selector: 'app-study-report-delivery-wizard',
  templateUrl: './study-report-delivery-wizard.component.html',
  styleUrls: ['./study-report-delivery-wizard.component.css'],
  providers: [{ provide: StudyReportDeliveryWizard, useClass: StudyReportDeliveryWizard }]
})
export class StudyReportDeliveryWizardComponent implements OnInit {

  @ViewChild('tabGroup', {static: false}) tabGroup: MatTabGroup;
  @ViewChild('studyReportDeliveryIdentification', {static: false}) studyReportDeliveryIdentification
  : StudyReportDeliveryDetailComponent;
  @ViewChild('studyReportDeliveryPatient', {static: false}) studyReportDeliveryPatient
  : StudyReportDeliveryPatientComponent;

  loadingAction: boolean;
  loading: boolean;
  validDelivery: boolean;

  constructor(private router: Router
    , private notificationToastService: NotificationToastService
    , private studyReportDeliveryWizard: StudyReportDeliveryWizard
    , private route: ActivatedRoute) {

  }

  cancel(): void {
    history.back();
  }

  private validateSteps(newIndex: number): boolean {
    const steps = this.getSteps();
    let inx = 0;
    let hasError = false;
    while (inx <= newIndex && steps.length > inx && !hasError) {
      hasError = !steps[inx].completed;
      inx = inx + 1;
    }
    if (hasError) {
      this.tabGroup.selectedIndex = inx - 1;
    }
    return hasError;
  }

  private getSteps() {
    const steps: WizardStep[] = [];
    // se tienen que agregar los pasos en el mismo orden que aparecen
      if (this.studyReportDeliveryIdentification
        && this.studyReportDeliveryIdentification.isInit) {
        steps.push(this.studyReportDeliveryIdentification);
      }

      if (this.studyReportDeliveryPatient
        && this.studyReportDeliveryPatient.isInit) {
          steps.push(this.studyReportDeliveryPatient);
    }

    return steps;
  }

  selectedIndexChange(newIndex: number): void {
    this.validateSteps(newIndex);
    const steps = this.getSteps();
    if (steps.length > newIndex) {
      steps[newIndex].activate();
    }
  }

  async finish() {
    this.loading = true;
    this.studyReportDeliveryWizard.finalizeDelivery().then(() => {
      this.loading = false;
      this.cancel();
    }).catch((err) => {
      this.notificationToastService.error(JSON.stringify(err.error), 'Entrega de informe');
      this.loading = false;
    }) ;
  }

  async print() {
    try {
      this.loading = true;
      await this.studyReportDeliveryWizard.printStudyReport();
    } catch ( err ) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Entrega de informe');
    } finally {
      this.loading = false;
    }
  }

 async sendMail() {
    try {
      this.loading = true;
      await this.studyReportDeliveryWizard.sendMail();
    } catch ( err ) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Entrega de informe');
    } finally {
      this.loading = false;
    }
  }

  ngOnInit() {
    this.loading = true;
    this.route.params.subscribe(async (params) => {
      const studyReportId = params['StudyReportId'];
        this.studyReportDeliveryWizard.initialize(studyReportId).then(() => {
          this.validDelivery = this.studyReportDeliveryWizard.isValidDelivery();
          this.loading = false;
          this.getSteps().forEach((step) => {
            step.activate();
          });
        }).catch((err) => {
          this.notificationToastService.error(JSON.stringify(err.error), 'Entrega de informe');
          this.loading = false;
        }) ;
    });
  }
}
